import { clearAuthSessionStorage, resetLogoutRedirectState } from './authSession';
import { notifyAccessTokenStateChanged } from './accessTokenState';
import { TOKEN_STORAGE_KEYS } from './constants';

export const getAccessToken = (): string | null => {
  return localStorage.getItem(TOKEN_STORAGE_KEYS.ACCESS_TOKEN);
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem(TOKEN_STORAGE_KEYS.REFRESH_TOKEN);
};

export const setTokens = (accessToken: string, refreshToken: string): void => {
  resetLogoutRedirectState();
  localStorage.setItem(TOKEN_STORAGE_KEYS.ACCESS_TOKEN, accessToken);
  localStorage.setItem(TOKEN_STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
  notifyAccessTokenStateChanged();
};

export const clearTokens = (): void => {
  clearAuthSessionStorage();
  notifyAccessTokenStateChanged();
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000;
    return Date.now() >= exp;
  } catch {
    return true;
  }
};

export const getTokenExpiration = (token: string): number | null => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000;
  } catch {
    return null;
  }
};
